import React, { useState } from "react";
import { Link } from "react-router-dom";
import Footer from "../components/Footer";
import PhoneSimulator from "../components/PhoneSimulator";
import LeadForm from "../components/LeadForm";
import { Button } from "../components/ui/button";
import { CheckCircle2, MessageCircle, FileText } from "lucide-react";

const FindPainter = () => {
  const [mode, setMode] = useState("form"); // 'form' | 'sim'
  const quickReplies = [
    "Nomvula M.", "Durbanville", "Repaint living room and 2 bedrooms, about 60m²", "interior", "next week", "YES",
  ];

  return (
    <div className="bg-white">
      <section className="py-12 md:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-12 items-start">
          <div className="lg:sticky lg:top-24">
            <div className="inline-flex items-center gap-2 bg-[#1E88E5]/10 text-[#1E88E5] px-3 py-1.5 rounded-full text-xs font-medium font-heading">
              For customers
            </div>
            <h1 className="font-heading mt-5 text-4xl sm:text-5xl font-bold text-[#2D3748] leading-tight tracking-tight">
              Need a painter?<br/>
              <span className="text-[#1E88E5]">Wazi will find one.</span>
            </h1>
            <p className="mt-5 text-lg text-[#718096] leading-relaxed">
              Fill out the quick form (recommended — attach photos!) or chat with Wazi as if you were on WhatsApp.
            </p>
            <ul className="mt-7 space-y-3">
              {["100% free for customers", "Real reviews you can trust", "Compare 3–5 quotes before deciding"].map((t) => (
                <li key={t} className="flex items-start gap-3 text-[#2D3748]">
                  <CheckCircle2 className="w-5 h-5 text-[#1E88E5] flex-shrink-0 mt-0.5" />
                  <span className="font-sans">{t}</span>
                </li>
              ))}
            </ul>
            <div className="mt-8 inline-flex bg-[#F7FAFC] border border-[#E2E8F0] rounded-full p-1" role="tablist">
              <button
                type="button"
                onClick={() => setMode("form")}
                data-testid="mode-form-btn"
                className={`px-4 py-2 rounded-full text-sm font-heading font-medium transition-all flex items-center gap-2 ${mode === "form" ? "bg-white text-[#2D3748] shadow-sm" : "text-[#718096]"}`}
              >
                <FileText className="w-4 h-4" /> Quick form
              </button>
              <button
                type="button"
                onClick={() => setMode("sim")}
                data-testid="mode-sim-btn"
                className={`px-4 py-2 rounded-full text-sm font-heading font-medium transition-all flex items-center gap-2 ${mode === "sim" ? "bg-white text-[#2D3748] shadow-sm" : "text-[#718096]"}`}
              >
                <MessageCircle className="w-4 h-4" /> WhatsApp demo
              </button>
            </div>
            <div className="mt-7 bg-[#F7FAFC] border border-[#E2E8F0] rounded-xl p-5">
              <div className="text-sm text-[#718096] mb-2 font-heading font-semibold">Prefer to chat right now on WhatsApp?</div>
              <a
                href="https://wa.me/27600702722?text=Hi%20Wazi%2C%20I%20need%20a%20painter."
                target="_blank"
                rel="noopener noreferrer"
                data-testid="findpainter-wa-deeplink"
                className="inline-flex items-center gap-2 text-[#25D366] font-medium hover:underline"
              >
                +27 60 070 2722 — open in WhatsApp →
              </a>
            </div>
            <Link to="/">
              <Button variant="outline" className="mt-8 rounded-full" data-testid="back-home-btn">← Back to home</Button>
            </Link>
          </div>
          <div>
            {mode === "form" ? (
              <LeadForm />
            ) : (
              <>
                <PhoneSimulator role="customer" sessionPrefix="findpainter" quickReplies={quickReplies} />
                <p className="mt-4 text-center text-sm text-[#718096]">Live demo — try a real lead request below.</p>
              </>
            )}
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default FindPainter;
